import type { ReviewEntry } from "@/src/data/home";

type ReviewsProps = {
  reviews: ReviewEntry[];
};

function Stars({ rating }: { rating: number }) {
  return (
    <div
      className="flex items-center gap-1"
      aria-label={`${rating} von 5 Sternen`}
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <span
          key={`star-${index}`}
          aria-hidden={true}
          className="text-sm text-amber-300"
        >
          {index < rating ? "★" : "☆"}
        </span>
      ))}
    </div>
  );
}

export function Reviews({ reviews }: ReviewsProps) {
  return (
    <div className="grid gap-4 lg:grid-cols-3">
      {reviews.map((review) => (
        <article
          key={review.id}
          className="group relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white/80 p-5 shadow-[0_12px_28px_rgba(30,41,59,0.1)] transition hover:-translate-y-1 hover:border-cyan-500/38"
        >
          <span className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-emerald-300/24 blur-2xl transition group-hover:bg-emerald-300/34" />
          <header className="flex items-start justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-slate-900">
                {review.name}
              </p>
              <p className="text-xs text-slate-500">{review.city}</p>
            </div>
            <Stars rating={review.rating} />
          </header>

          <p className="mt-4 text-2xl leading-none text-cyan-600/75">“</p>
          <p className="-mt-1 text-sm leading-relaxed text-slate-700">
            {review.quote}
          </p>

          <footer className="mt-4 border-t border-slate-200/80 pt-3 text-xs text-slate-500">
            <p>{review.product}</p>
            <p className="mt-1">{review.date}</p>
            {review.verified ? (
              <p className="mt-2 inline-flex rounded-full border border-emerald-500/35 bg-emerald-100/76 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-[0.08em] text-emerald-800">
                Verifizierter Kauf
              </p>
            ) : null}
          </footer>
        </article>
      ))}
    </div>
  );
}
